import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { InventoryVS } from 'shared/utils/validation/AuthValidation';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';


export default function UpdateInvenotyMod({ data, show, handleClose, updateHandler, outnot }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const [stockIn, setStockIn] = useState('');
    const [initialValues, setInitialValues] = useState({
        quantity: ''
    });
    const [isInvalid, setIsInvalid] = useState(false);
    const [isClosed, setIsClosed] = useState(false);

    const onClose = () => {
        handleClose();
        formik.resetForm();
        setStockIn('');
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: InventoryVS,
        onSubmit: (value) => {
            let updatedQty;
            let remainingValue;

            if (outnot) {

                updatedQty = Number(stockIn || 0);
                remainingValue = Number(data?.quantity || 0) - updatedQty;
            } else {

                updatedQty = Number(data?.quantity || 0);
                if (stockIn) {
                    updatedQty += Number(stockIn);
                    if (data.remaining > 0) {
                        remainingValue = data?.remaining - Number(stockIn);
                    }
                }
            }

            let obj = {
                ...value,
                quantity: updatedQty,
                inventory: data?._id,
                remaining: remainingValue ?? data?.remaining,
                closed: isClosed || (remainingValue ?? data?.remaining) === 0 ? "true" : "false", // ✅ toggle overrides


            };


            // Only add Remaining when outnot is true
            if (outnot) {
                obj.Remaining = remainingValue;
                obj.poqty = data?.quantity
            }
            updateHandler(obj);
        }

    });

    const { handleChange, handleSubmit, values, touched, errors } = formik;

    useEffect(() => {
        setInitialValues({
            quantity: data?.quantity || 0
        });
        setStockIn('');
        setIsClosed(data?.closed === "true");

    }, [data]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className={styles.Header}>
                <Heading heading={'Update Inventory'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>

            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>

                    {/* Tabs */}
                    <div className={styles.TabContainer}>
                        <div
                            className={classNames(styles.Tab, styles.ActiveTab)}
                        >
                            Stock In
                        </div>
                    </div>

                    <CustomInput
                        label={`Stock In`}
                        placeholder={'e.g. 10'}
                        type="number"
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={stockIn}
                        onChange={(e) => setStockIn(e.target.value)}
                    />



                    {/* Price */}
                    {/* <CustomInput
                        label={`Price`}
                        placeholder={'e.g. 123'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values?.price}
                        onChange={handleChange('price')}
                        error={errors.price && touched.price ? errors.price : ''}
                    /> */}

                    {/* Quantity */}
                    <CustomInput
                        label={`Quantity`}
                        placeholder={'e.g. 123'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.disable, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values?.quantity}
                        error={errors.quantity && touched.quantity ? errors.quantity : ''}
                        onChange={handleChange('quantity')}
                    />
                    <div className="mb-3">
                        <label className="me-2">Closed:</label>
                        <input
                            type="checkbox"
                            checked={isClosed}
                            onChange={(e) => setIsClosed(e.target.checked)}
                        />
                    </div>


                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={onClose} />
                        <CustomButton text={'Update'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} invalid={isInvalid} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
